import { observer } from 'mobx-react-lite'
import { Icon, SpinnerLoader, Typography } from 'shared/ui'
import { RegisterSection } from 'pages/settings/pages/compliance/ui/RegisterSection/RegisterSection'
import { useCompliancePageContext } from 'pages/settings/pages/compliance/context'
import { SummaryInternational } from 'pages/settings/pages/compliance/ui/Summary/SummaryInternational'
import styles from 'pages/settings/pages/compliance/ui/styles.module.scss'

export const InternationalPage = observer(() => {
  const { internationalPageStore } = useCompliancePageContext()

  const { internationalRegulation, loading, internationalLabel, internationalFlagIcon } =
    internationalPageStore

  if (loading) return <SpinnerLoader ariaLabel={'internationalPage'} />

  return (
    <>
      {!internationalRegulation?.isSubmitted && (
        <RegisterSection {...internationalPageStore.internationalRegisterSectionProps} />
      )}
      {internationalRegulation?.isSubmitted && (
        <div>
          <Typography
            tag='div'
            marginBottom={'17px'}
            color='var(--content-primary-primary)'
            ariaLabel='AfterRegisterSection_header'
            className={styles.sectionTitle}
          >
            <Typography
              ariaLabel='InternationalRegisterText'
              variant='body-lg-medium'
              className={styles.sectionTitleText}
            >
              {internationalLabel}
            </Typography>
            {internationalFlagIcon && <Icon className={styles.flag} icon={internationalFlagIcon} />}
          </Typography>
          <SummaryInternational />
        </div>
      )}
    </>
  )
})
